import { RequestService } from '../../../../../common/services/RequestService';
import { API_AUTHORIZATION_CHECKCODE } from '../../constants';

export const checkCodeRequest = payload => {
  return RequestService.post(
    API_AUTHORIZATION_CHECKCODE,
    JSON.stringify(payload)
  );
};
